import vueAuth from '@common/lib/auth';
import { stringify } from 'query-string';
import ApiService from '@common/lib/api/api.service';
import { AuthService, UserService } from '@common/lib/api';
import * as auth from './types';
import * as common from '@common/store/modules/common/types';

export default {
  [auth.LOGIN](context, credentials) {
    // The Promise used for router redirect in login
    return new Promise((resolve, reject) => {
      return (
        vueAuth
          /*.login({
          user: credentials,
        })*/
          .login(
            stringify({
              username: credentials.username,
              password: credentials.password,
              roles: credentials.roles,
            }),
          )
          .then(async ({ data }) => {
            console.log('login', data);
            //context.commit(auth.SET_AUTH, data.user);
            //getData
            const userInfo = await context.dispatch(auth.CHECK_AUTH);

            const appName = process.env.VUE_APP_APP_NAME;
            //console.log('userInfo', userInfo, appName);
            if (userInfo && (appName === 'customer' || appName === 'owner')) {
              const userDeviceInfo = await context.dispatch(
                auth.UPDATE_USER_DEVICE_INFO,
              );
              //console.log('userDeviceInfo', userDeviceInfo);
            }
            resolve(data);
          })
          .catch(({ response }) => {
            //context.commit(auth.SET_ERROR, response.data.errors);
            reject(response);
          })
      );
    });
  },
  async [auth.LOGIN_PROVIDER](context, provider) {
    const { authResponse } = await vueAuth.loginProvider(provider);
  },
  async [auth.LOGOUT](context) {
    return new Promise((resolve, reject) => {
      const payload = {
        method: 'PUT',
        data: {
          notificationToken:
            context.rootState.common.appInfo.fbToken ||
            (window.$bridge ? window.$bridge.deviceInfo.registrationKey : '') ||
            '',
          deviceAppType:
            context.rootState.common.appInfo.appType ||
            window.$bridge.deviceInfo.appType ||
            '',
        },
      };
      //token이 없으면 purge처리만.
      if (payload.data.notificationToken === '') payload.purge = true;
      return vueAuth.logout(payload).then(() => {
        context.commit(auth.PURGE_AUTH);
        resolve(true);
      });
    });
  },
  async [auth.CHECK_AUTH](context, credentials) {
    return new Promise(async (resolve, reject) => {
      //console.log('check_auth call');
      const isAuthenticated = await vueAuth.isAuthenticated();
      if (isAuthenticated) {
        return vueAuth
          .getUser()
          .then(({ data }) => {
            context.commit(auth.SET_AUTH, data);
            let act = common.ROOT_HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG;
            if (data.isRequiredUpdatePassword) {
              act = common.ROOT_SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG;
            }
            context.dispatch(act, null, {
              root: true,
            });
            resolve(true);
          })
          .catch(({ response }) => {
            //context.commit(auth.SET_ERROR, response.data.errors);
            reject();
          });
      } else {
        context.commit(auth.PURGE_AUTH);
        return resolve(false);
      }
    });
  },
  async [auth.UPDATE_USER_DEVICE_INFO](context, payload) {
    if (!payload) {
      payload = {
        notificationToken:
          context.rootState.common.appInfo.fbToken ||
          window.$bridge.deviceInfo.registrationKey ||
          '',
        deviceAppType:
          context.rootState.common.appInfo.appType ||
          window.$bridge.deviceInfo.appType ||
          '',
      };
    }
    return new Promise((resolve, reject) => {
      if (!payload.notificationToken) {
        resolve(false);
        return;
      }
      return UserService.saveDeviceInfo(payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  async [auth.DELETE_USER_DEVICE_INFO](context, payload) {
    if (!payload) {
      payload = {
        notificationToken:
          context.rootState.common.appInfo.fbToken ||
          window.$bridge.deviceInfo.registrationKey ||
          '',
        deciceAppType: window.$bridge.deviceInfo.appType,
      };
    }
    return new Promise((resolve, reject) => {
      if (!payload.notificationToken) {
        resolve(false);
        return;
      }
      return UserService.removeDeviceInfo(payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [auth.AUTH_REQ](context, payload) {
    const { inputValue, authType } = payload;
    const params = {
      receiver: inputValue,
      receiverType: authType,
    };
    return new Promise((resolve, reject) => {
      return AuthService.AuthReq(params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [auth.AUTH_CONFIRM](context, payload) {
    const { inputValue, authNumber, authType } = payload;
    const params = {
      code: authNumber,
      receiver: inputValue,
      receiverType: authType,
    };
    return new Promise((resolve, reject) => {
      /*return vueAuth
        .loginMobile(stringify(params))
        .then(({ data }) => {
          context.commit(auth.SET_AUTH, data.user);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(auth.SET_ERROR, response.data);
          reject(response.data);
        });*/
      return AuthService.AuthConfirm(params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [auth.SET_ERROR]({ commit }, errors) {
    commit({
      errors,
    });
  },
  //모바일 회원 가입 (SMS)
  [auth.REGISTER_MOBILE](context, credentials) {
    return new Promise((resolve, reject) => {
      return vueAuth
        .register(credentials, {
          url: `${vueAuth.options.registerUrl}/mobile`,
        })
        .then(({ data }) => {
          context.commit(auth.SET_AUTH, data.user);
          resolve(data);
        })
        .catch(({ response }) => {
          //context.commit(auth.SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  //모바일 회원 가입 (SMS)
  [auth.REGISTER_OWNER](context, credentials) {
    return new Promise((resolve, reject) => {
      return vueAuth
        .register(credentials, {
          url: `${vueAuth.options.registerUrl}/owner`,
        })
        .then(({ data }) => {
          context.commit(auth.SET_AUTH, data.user);
          resolve(data);
        })
        .catch(({ response }) => {
          //context.commit(auth.SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  async [auth.SOCIAL_CHECK](context, params) {
    const { data } = await AuthService.socialCheck(params);
    return data;
  },
  async [auth.SOCIAL_REGISTER](context, params) {
    const { data } = await AuthService.socialRegister(params);
    return data;
  },
};
